module.exports = __webpack_public_path__ + "static/youles_screenshot-e928ae842483aee1b45a2d56d7be0678.png";